(function () {
  function initCarousel(root) {
    const frame = root.querySelector('.bewo-tips__frame');
    if (!frame || frame.dataset.carouselReady === 'true') return;
    frame.dataset.carouselReady = 'true';

    const items = Array.from(frame.querySelectorAll('.bewo-tips__card'));
    if (!items.length) return;

    const prev = frame.querySelector('.bewo-tips__arrow--prev');
    const next = frame.querySelector('.bewo-tips__arrow--next');
    const dotsRoot = frame.querySelector('.bewo-tips__dots');
    const swipeTarget = frame.querySelector('.bewo-tips__track') || frame;

    const startIndex = Number(root.dataset.startIndex || 0);
    let active = items.findIndex((item) => item.classList.contains('is-active'));
    if (active < 0) active = Math.min(Math.max(startIndex, 0), items.length - 1);

    const dots = [];

    if (dotsRoot) {
      dotsRoot.innerHTML = '';
      items.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bewo-tips__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Dica ${index + 1}`);
        dot.addEventListener('click', () => {
          active = index;
          render();
        });
        dotsRoot.appendChild(dot);
        dots.push(dot);
      });
    }

    const render = () => {
      items.forEach((item, index) => {
        const isActive = index === active;
        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-side', !isActive);
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-selected', index === active ? 'true' : 'false');
      });
    };

    const step = (delta) => {
      active = (active + delta + items.length) % items.length;
      render();
    };

    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));

    let touchStartX = 0;
    let touchStartY = 0;

    swipeTarget.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
      },
      { passive: true }
    );

    swipeTarget.addEventListener(
      'touchend',
      (event) => {
        const deltaX = event.changedTouches[0].screenX - touchStartX;
        const deltaY = event.changedTouches[0].screenY - touchStartY;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        step(deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-bewo-tips]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-bewo-tips]');
    if (root) initCarousel(root);
  });
})();
